import React from "react";
import ReactQuill from "react-quill";
import PropTypes from "prop-types";

const modules = {
   toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      [
         { align: "" },
         { align: "center" },
         { align: "right" },
         { align: "justify" },
      ],
      ["link"],
   ],
};

const formats = [
   "header",
   "bold",
   "italic",
   "underline",
   "strike",
   "blockquote",
   "list",
   "bullet",
   "font",
   "size",
   "link",
   "align",
];

const FormDesCription = ({ inputChange, value, label }) => {
   return (
      <>
         <p>{label} </p>
         <ReactQuill
            value={value}
            onChange={inputChange}
            modules={modules}
            formats={formats}
            theme="snow"
            style={{ height: "100px", marginBottom: "80px" }}
         />
      </>
   );
};

FormDesCription.propTypes = {
   inputChange: PropTypes.func.isRequired,
   value: PropTypes.any.isRequired,
   label: PropTypes.string,
};

export default FormDesCription;
